import { defineMessage } from 'react-intl';
import type { IntlShape } from 'react-intl';
import * as yup from 'yup';

const billingPostcodeRequiredMessage = defineMessage({
    id: '_.link_debit_card.billing_postcode_required',
    defaultMessage: 'Billing postcode is required'
});

const cardholderNameRequiredMessage = defineMessage({
    id: '_.link_debit_card.cardholder_name_required',
    defaultMessage: 'Cardholder name is required'
});

export const createLinkDebitCardSchema = (intl: IntlShape, country: string) => {
    const billingPostcodeRequired = intl.formatMessage(
        billingPostcodeRequiredMessage
    );
    const cardholderNameRequired = intl.formatMessage(
        cardholderNameRequiredMessage
    );

    const billingPostcode = yup
        .string()
        .test('valid-postcode', billingPostcodeRequired, (value) => {
            if (country === 'DE') {
                return !!value && value.length === 5;
            }
            // UK / fallback: any non-empty value passes.
            return !!value;
        });

    const cardholderName = yup
        .string()
        .test('required', cardholderNameRequired, (value) => !!value);

    return yup.object({
        billingPostcode,
        cardholderName
    });
};
